import React from 'react';
import Image from 'next/image';
import { ReadyToChoiceContainer } from './TopBannerwithtext/styled';
import { isDesktopUser } from '../../Utils/ProductUtils';
import { fireEvent } from '../../Utils/fireEvent';

export default function ReadyToChoiceSection(props) {
  const {
    particularRef,
    goTopRef,
    rtcImages,
    setShowAnimation,
    setShowHeader,
    setShowTop,
    setShowLockedProductsAnimation,
    productCount,
    isForNewCdPage,
    lockedProductSectionRef,
    nonFreebieProductCount,
  } = props;

  const particularElementHandler = () => {
    fireEvent({
      category: 'clicked_cta',
      screen_name: 'Category Page',
      cta: '',
      parent: 'Jump',
      page_url: window.location.href,
      section_name: 'Ready to Choice Section',
    });
    if (isForNewCdPage) {
      if (productCount >= 2 && nonFreebieProductCount >= 2) {
        const element = lockedProductSectionRef.current;
        const offset = 70;
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: elementPosition - offset,
          behavior: 'smooth',
        });

        setShowLockedProductsAnimation(true);
        setTimeout(() => {
          setShowLockedProductsAnimation(false);
        }, 1000);
        if (!isDesktopUser()) {
          setTimeout(() => {
            setShowAnimation(false);
            setShowHeader('-56px'); // for Mweb
            setShowTop(true);
          }, 1000);
        }
      } else {
        particularRef.current?.scrollIntoView({ behavior: 'smooth' });
        if (setShowAnimation) {
          setShowAnimation(true);

          if (!isDesktopUser()) {
            setTimeout(() => {
              setShowAnimation(false);
              setShowHeader('-56px'); // for Mweb
              setShowTop(true);
            }, 1000);
          }
        }
      }
    } else {
      particularRef.current?.scrollIntoView({ behavior: 'smooth' });
      if (setShowAnimation) {
        setShowAnimation(true);

        if (!isDesktopUser()) {
          setTimeout(() => {
            setShowAnimation(false);
            setShowHeader('-56px'); // for Mweb
            setShowTop(true);
          }, 1000);
        }
      }
    }
  };

  const getDesktopImage = (product) => {
    return product?.readyToChoicemDesktop;
  };
  const getMobileImage = (product) => {
    return product?.readyToChoicemWeb;
  };

  return (
    <ReadyToChoiceContainer onClick={particularElementHandler} ref={goTopRef}>
      {/* {DiaperBannerImages?.map((element, index) => {
                return ( */}
      <React.Fragment>
        <Image
          className="carousel-mobile"
          src={getMobileImage(rtcImages)}
          alt="clothdiaperbannermobile"
          quality={90}
          load="lazy"
          fill
          sizes="60vw"
        />
        <Image
          className="carousel-desktop"
          src={getDesktopImage(rtcImages)}
          alt="clothdiaperbannerdesktop"
          quality={90}
          fill
          sizes="100vw"
        />
      </React.Fragment>
    </ReadyToChoiceContainer>
  );
}
